import koLocale from 'element-ui/lib/locale/lang/ko'// element 언어 팩 도입
const ko = {
    posterPage: {
        title1: '구독 기능이 곧 오픈됩니다!',
        title2: '구독 갱신, 특권 업그레이드!',
        title3: '특별 할인, 추가 비용',
        title4: '교환 코드를 받으려면 장비를 구매하는 판매자에게 문의하십시오.',
        title5: '우선 순위 기능',
        function1: '기능 상세 정보:',
        function2: '기본 서비스 갱신 요금 (동시통역, 회의 보조, 스마트 보조)..',
        function3: '부가 서비스 구독(오프라인 번역, 음성 및 화상 통화 번역)..',
    },
    RedemptionCodePage: {
        RedemptionCode: '교환 코드',
        ValueAddedServices: '부가 가치 서비스',
        UpgradedExperience: '전속 부가가치 권익, 체험 업그레이드',
        OfflineTranslation: '오프라인 번역',
        NoInternet: '네트워킹 불필요·인스턴트 번역·보안',
        GoToSubscribe: '구독하기',
        AudioAndVideoCall: '음/영상통화',
        RealTimeCall: '실시간 음성 번역·소통 무장애',
        BaseService: '기본 서비스',
        AIAssistant: '기능: 동시 통역·회의 보조·AI 보조',
        LanguagesSetting: '언어 설정',
        languages1: '중국어 간체',
        languages2: '중국어 번체',
        languages3: '영어',
        languages4: '일본어',
        languages5: '한국어',
        languages6: '러시아어',
        languages7: '스페인어',
        languages8: '프랑스어',
        languages9: '독일어',
        languages10: '포르투갈어',
        languages11: '이탈리아어',
        languages12: '터키어',
        languages13: '베트남어',
        languages14: '인도네시아어',
        languages15: '힌디어',
        languages16: '아랍어',
        languages17: '태국어',
        languages18: '페르시아어',
    },
    Login: {
        ToLogin: '로그인',
        PhoneLogin: '핸드폰 번호 로그인',
        EmailLogin: '메일박스 로그인',
        PhonePlaceholder: '핸드폰 번호를 입력하세요.',
        EmailPlaceholder: 'Enter email',
        Code: '인증 코드',
        and: '및',
        BeforeText: '계좌를 만드는 동시에 당신이 동의하고 준수하는 것을 대표합니다',
        UserAgreement: '사용자 프로토콜',
        privacy: '개인 정보 보호 정책',
        errorMessage: '인증 코드 오류',
        readTitle: '다음 계약을 읽고 동의합니다.',
        readBefore: '귀하의 개인 정보를 안전하게 보호하려면 먼저 읽고 동의하십시오.',
        cancel: '취소',
        agree: '동의 및 계속 ',
        error1: '올바른 이메일 주소를 입력하십시오.',
        error2: '정확한 핸드폰 번호를 입력하세요.',
        error3: '인증 코드를 입력하십시오.',
        success: '로그인 성공'
    },
    OffLinePage: {
        title: '오프라인 번역',
        NoInternet: '네트워킹 불필요·인스턴트 번역·보안',
        ServiceLife: '사용 기간',
        forever: '영구 사용',
        describe: '가입 설명',
        describeItem1: '1.오프라인 번역 기능은 일시불, 영구 사용, 사용 권한은 Bluetooth 장치를 따라, 장치를 교체하는 경우 오프라인 번역 교환 코드를 다시 구독해야합니다.',
        describeItem2: '2. 라이선스 코드는 구독 후 환불할 수 없습니다.',
        describeItem3: '3.중국어, 영어, 독일어, 일본어, 한국어, 힌디어, 태국어, 스페인어, 프랑스어, 러시아어 등 10개 언어 지원',
        quantity: '수량',
        payType: '지불 방법',
        card: '은행카드',
        wx: '위챗',
        GooglePay: 'Google Pay',
        subscribe: '가입',
        RMB: '¥',
        confirm: '확인',
        cardNumber: '카드 번호',
        periodOfValidity: '유효기간',
        safetyCode: '보안 코드',
        name: '이름',
        yearAndMonth: '년 / 월 ',
        message1: '수량은 0이 될 수 없습니다.',
        popTip:'따뜻한 힌트',
        popText1:'자세히 읽고 이해하십시오.',
        popText2:'오프라인 번역 유료 프로토콜',
        popText3:'읽고 동의함',
        popText4:'읽기 및 동의',
    },
    AudioVideoPage: {
        title: '음/영상통화',
        RealTime: '실시간 음성 번역·소통 무장애',
        describe: '가입 설명',
        describeItem1: '1.오프라인 번역 기능은 일시불, 영구 사용, 사용 권한은 Bluetooth 장치를 따라, 장치를 교체하는 경우 오프라인 번역 교환 코드를 다시 구독해야합니다.',
        describeItem2: '2. 계정 충전 후 다른 장치를 연결하고 바인딩하면 그대로 사용할 수 있습니다.',
        describeItem3: '3. 음성·영상통화 번역 기능 충전 후 환불 불가.',
        payType: '지불 방법',
        card: '은행카드',
        wx: '위챗',
        GooglePay: 'Google Pay',
        subscribe: '가입',
        RMB: '¥',
        sale: '할인',
        confirm: '확인 ',
        time1: '초',
        time2: '분',
        time3: '시간',
        time4: '일',
        time5: '월',
        time6: '년',
    },
    OffLineResult: {
        title1: '오프라인 번역',
        title2: '음/영상통화',
        title3: '기본 서비스',
        success: '가입 성공',
        fail: '가입 실패',
        stock: '교환 코드 준비 중',
        saveTitle: '교환 코드를 저장하고 APP에 가서 교환 사용을 진행합니다',
        code: '교환 코드',
        tip1: '이 코드는 오프라인 번역 기능을 교환하는 데만 사용됩니다.',
        tip2: '이 코드는 음성 / 화상 통화 번역 기능을 교환하는 데만 사용됩니다.',
        tip3: '이 코드는 기본 서비스 갱신 기능을 교환하는 데만 사용됩니다.',
        save: '저장',
        time: '가입 시간:',
        copy: '복사',
        copySuccess: '복제 성공 ',
        loading: '로드 중',
        paySuccess:'결제 성공'
    },
    RedemptionList: {
        title: '내 교환코드',
        view: '보기',
        time: '가입 시간:',
    },
    MyRedemption: {
        title: '내 교환코드',
        code: '교환 코드',
        time: '가입 시간:',
        copy: '복사',
        tip1: '이 코드는 오프라인 번역 기능을 교환하는 데만 사용됩니다.',
        tip2: '이 코드는 음성 / 화상 통화 번역 기능을 교환하는 데만 사용됩니다.',
        tip3: '이 코드는 기본 서비스 갱신 기능을 교환하는 데만 사용됩니다.',
        save: '저장',
        success: "작업 성공"
    },
    basePage: {
        error1: '상품 정보를 얻지 못했습니다.',
        message1: '상품을 선택하세요',
        title: '기본 서비스',
        function: '기능: 동시 통역·회의 보조·AI 보조',
        describe: '가입 설명',
        describe1: '1.동전 번역, 회의 보조 등 기초 서비스 갱신 후, 유효 기간은 설비를 따라가며, 설비를 교체할 경우 다시 갱신해야 한다.',
        describe2: '2. 기본 서비스 갱신 후 환불 불가.',
        payType: '지불 방법',
        card: '은행카드',
        wx: '위챗',
        GooglePay: 'Google Pay',
        subscribe: '가입',
        RMB: '¥',
        sale: '할인',
        month: '월',
        confirm: '확인 ',
        month1: '한 달',
        month2: '반년',
        month3: '1년'
    },
    ...koLocale // 언어를 전환할 때 element 구성 요소의 텍스트가 전환에 따라 이동할 수 있도록 element 언어 팩을 도입합니다
}
// 내보내기
export default ko;
